<template>
    <div class="add-work-qq">
        <div class="content">
            <div class="data-title">
                <div class="title-name">新增工作QQ号</div>
            </div>
            <div class="text">基本信息</div>
            <div class="forms">
                <el-form :inline="true" :model="form" ref="form" :rules="rules" class="form" size="small" label-width="96px" autocomplete="off">
                    <el-form-item label="工作QQ号" prop="account">
                        <el-input v-model="form.account" placeholder="请输入" maxlength="12" clearable show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="QQ号密码" prop="password">
                        <el-input
                            type="text"
                            style="display: none;"
                            autocomplete="username">
                            </el-input>
                        <el-input v-model="form.password" autocomplete="new-password"  placeholder="请输入" maxlength="24" :type="eye?'text':'password'">
                            <i slot="suffix" :class="[eye?'i-eye':'i-eye-hide']" @click="onEye"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="QQ号实名人" class="t-label">
                        <template #label>
                            <div class="custom-label">QQ号<br />实名人</div>
                        </template>
                        <el-input v-model="form.name" placeholder="请输入" clearable maxlength="30" type="textarea" style="width: 204px;" rows="3" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="QQ号 绑定手机号" prop="phone">
                        <template #label>
                            <div class="custom-label">QQ号<br />绑定手机号</div>
                        </template>
                        <el-input v-model="form.phone" placeholder="请输入" maxlength="11" clearable show-word-limit @input="checkPhone"></el-input>
                    </el-form-item>
                    <el-form-item label="绑定手机号所属员工" class="t-label">
                        <template #label>
                            <div class="custom-label">绑定手机号<br />所属员工</div>
                        </template>
                        <el-input v-model="accountName" placeholder="自动识别" style="width: 204px;" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="QQ号好友数" class="t-label" prop="friendsCount">
                        <template #label>
                            <div class="custom-label">QQ号<br />好友数</div>
                        </template>
                        <el-input v-model="form.friendsCount" placeholder="请输入" clearable maxlength="8" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="QQ号备注" class="t-label" prop="remarks">
                        <el-input v-model="form.remarks" placeholder="请输入" clearable maxlength="64" type="textarea" style="width: 204px;" rows="3" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
                <el-button type="info" plain @click="back">返回</el-button>
                <el-button type="primary" plain @click="reset">重置</el-button>
                <el-button type="primary" @click="save" :loading="btnSave">保存</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { REGEX } from '@/pages/assetManagement/common/consts/regex.js';

export default {
    name: 'workQQAdd',
    computed: {
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    data() {
        return {
            form: {
                account: '',
                password: '',
                name: '',
                friendsCount:'',
                remarks: '',

            },
            btnSave: false,
            rules: {
                account: [
                    { required: true, message: '请输入工作QQ号', trigger: 'blur' },
                    { pattern: REGEX.QQ, message: '请输入正确的QQ号', trigger: ['blur','change']  }
                ],
                password: [
                    { required: true, message: '请输入QQ号密码', trigger: 'blur' }
                ],
                phone: [
                    { pattern: REGEX.PHONE, message: '请输入11位手机号',trigger: ['blur','change']  }
                ],
                friendsCount: [
                    { pattern: REGEX.COUNT, message: '请输入数字', trigger: 'change' }
                ]
            },
            eye:  false,
            accountName:''
        }
    },
    activated() {
        this.reset()
    },
    created() {
        for(const type in this.dictionaries){
            this.getDictionaries(type)
        }
    },
    methods: {
        checkPhone(value){
            if(REGEX.PHONE.test(value)){
                let account = value
                this.$api.workPhoneFindName({account}).then(res => {
                    if (res.code == 0) {
                        this.accountName = res.data || '该手机号无登记'
                    }else{
                        this.accountName = '该手机号无登记'
                    }
                })
            }else{
                this.accountName = ''
            }
        },
        onEye(){
            this.eye = !this.eye
        },
        back() {
            this.$router.go(-1)
        },
        reset() {
           this.form = {}
           this.accountName = ''
           this.$refs.form.resetFields()
        },
        save() {
            console.log('>>', this.form)
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.btnSave = true
                    this.form.phone = this.form.phone ? this.form.phone : null
                    this.$api.workQQSave(this.form).then((res) => {
                        if (res.code == 0) {
                            this.$message({ message: '新增成功', type: 'success' })
                            this.back()
                        }
                    }).finally(() => {
                        this.btnSave = false
                    })
                }
            })
        },
        //获取字典数据
        getDictionaries(type){
          if(type && this.dictionaries[type].length > 0){
            return
          }
          const params = { groupId: type }
          this.$api.dictionaries(params).then(res => {
            this.dictionaries[type] = res.data || []
          }).catch((err) => {
                console.log(err)
            })
         },
    },
}
</script>
<style lang="scss" src="@/pages/assetManagement/common/style/workQQ.scss" scoped />